import React from 'react'
import './about_me.css'
import { motion } from 'framer-motion';

const AboutMe = () => {
  return (
    <motion.div
    initial={{
     opacity:0,
     y:40
    }} 
    whileInView={
     {
       opacity:1,
       y:0
     }
    }
    
    transition={{
     delay:0.2,
     duration:0.5
    }}
    viewport={{
      once:true
     }}
      className='about_me'  id="aboutMey">
      <h2 style={{marginTop:"100px"}} className='heading'>About Me</h2>
    <div className="about_me_info">
        <p className='about_me_left'>With over 3 years of experience as a MERN Stack Developer, I specialize in building scalable and efficient web and mobile applications using the latest technologies. My expertise encompasses MongoDB, Express.js, React.js, and Node.js, which enables me to create dynamic, full-stack solutions tailored to user needs.<br/><br/>

I have successfully led teams for both government and private sector clients, including renowned organizations such as the Indian Navy, SAIL, ONGC, JVVNL, as well as private companies like Healthnut LA, Teesas, Hotbox Cookies, and also delivered TV application solutions. My experience in leading diverse teams and managing high-impact projects has refined my skills in delivering quality, timely solutions while ensuring optimal client satisfaction.

With a strong foundation in JavaScript, HTML, CSS, and frameworks like Next.js and AngularJS, I am passionate about tackling complex technical challenges, fostering collaboration, and mentoring teams to drive growth, innovation, and success.</p>
        {/* <div className="about_me_right"></div> */}
    </div>

    </motion.div>
    
  )
}

export default AboutMe
